var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-form-group',{attrs:{"id":_vm.name,"label":_vm.label,"label-for":_vm.name}},[_c('editor',{attrs:{"api-key":"1tm8qm9at2m3557gxm2ahn763maxteqbzsoba997shbhlgby","init":{
     height: 500,
     menubar: false,
     plugins: [
       'advlist autolink lists link image charmap print preview anchor',
       'searchreplace visualblocks code fullscreen',
       'insertdatetime media table paste code help wordcount'
     ],
     toolbar:
       'undo redo | formatselect | fontsizeselect | bold italic backcolor | \
       alignleft aligncenter alignright alignjustify | \
       bullist numlist outdent indent | removeformat | link | code | image'
   }},on:{"input":_vm.updateField},model:{value:(_vm.editorData),callback:function ($$v) {_vm.editorData=$$v},expression:"editorData"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }